export const xs = 2;
export const s = 4;
export const m = 6;
export const l = 12;

export default { xs, s, m, l };